// src/admin/components/common/DateTimeDisplay.jsx

import React from 'react';
import PropTypes from 'prop-types';
import { formatDate, formatTime } from '../../../shared/utils/formatDate';

/**
 * Displays a date and time in a stacked format:
 * - Date on the first line
 * - Time on the second line (muted)
 */
export default function DateTimeDisplay({ isoString, fallback = '—' }) {
  if (!isoString) {
    return <span className="text-muted">{fallback}</span>;
  }

  const dateStr = formatDate(isoString, fallback);
  const timeStr = formatTime(isoString, '');

  return (
    <div className="d-flex flex-column">
      <span>{dateStr}</span>
      {timeStr && (
        <small className="text-muted">{timeStr}</small>
      )}
    </div>
  );
}

DateTimeDisplay.propTypes = {
  isoString: PropTypes.string,
  fallback: PropTypes.string,
};

